import { withInstall } from '@hd-front-end/utils'
import Icon from './src/icon.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElIcon: SFCWithInstall<typeof Icon> = withInstall(Icon)
export default ElIcon

export * from './src/icon'
